function Button({name}) {
    return (
        <button>{name}</button>
    )
}
export default Button;